import React, { Component } from "react";
import PropTypes from "prop-types";
import Image from "theme/components/atoms/Image";
import useFullUrl from "web/core/shop/useFullUrl";
import classnames from "classnames";
import withFormHandlers from "theme/components/atoms/Form/Input/withFormHandlers";

const isHexColor = (color) => /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
const blurClosestButton = (target) => {
  if (target.tagName === "BUTTON") {
    target.blur();
  } else if (Element.prototype.closest) {
    target.closest("button").blur();
  }
};

const ColorSwatch = (props) => {
  return (
    <span
      className={classnames("swatches__color")}
      aria-label={props.label}
      style={{ backgroundColor: props.value }}
    />
  );
};

const ImageSwatch = (props) => {
  const url = useFullUrl(props.value);
  return (
    <span className={classnames("swatches__image")}>
      <Image
        src={url}
        alt={props.label}
        format="thumbnail"
        appearance="full-rounded"
      />
    </span>
  );
};

const SwatchButton = (props) => {
  return (
    <button
      type="button"
      onClick={props.onClick}
      key={props.option.value}
      className={classnames("swatches__value", {
        "swatches__value--selected": props.isSelected,
        "swatches__value--disabled": props.option.disabled,
      })}
      disabled={props.option.disabled}
    >
      {isHexColor(props.option.swatch.value) ? (
        <ColorSwatch
          value={props.option.swatch.value}
          label={props.option.label}
        />
      ) : (
        <ImageSwatch
          value={props.option.swatch.value}
          label={props.option.label}
        />
      )}
    </button>
  );
};

class Swatches extends Component {
  constructor() {
    super();
    this.selectSwatch = this.selectSwatch.bind(this);
  }

  selectSwatch(value) {
    if (value.disabled) {
      return;
    }
    this.props.onChange(value.value);
  }

  render() {
    return (
      <div className="swatches">
        {this.props.options.map((option, index) => {
          const isSelected = this.props.value
            ? option.value === this.props.value ||
              option.value === this.props.value.value
            : false;

          return (
            <SwatchButton
              key={option.value}
              option={option}
              isSelected={isSelected}
              onClick={(event) => {
                event.preventDefault();
                blurClosestButton(event.target);
                this.selectSwatch(option);
              }}
            />
          );
        })}
      </div>
    );
  }
}

Swatches.propTypes = {
  label: PropTypes.node.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      swatch: PropTypes.shape({
        value: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
};

export default withFormHandlers({
  dirtyOnChange: true,
  getValueFromEvent: (value) => value,
})(Swatches);
